/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

export type StartExportRequestSchemaFormat = typeof StartExportRequestSchemaFormat[keyof typeof StartExportRequestSchemaFormat];


export const StartExportRequestSchemaFormat = {
  pdf: 'pdf',
  csv: 'csv',
  'csv+pdf': 'csv+pdf',
} as const;
